var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"583996c06835f27e8a0b68e2ea65d508682a9859"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["spoox@play-inc"]={id:"583996c06835f27e8a0b68e2ea65d508682a9859"};
      